import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import App from './App';

const cookies = new Cookies();

class Landing extends Component {
  constructor(props) {
    super(props);
    /* If no cookies then need harmless defaults */
    this.state = {
        page_opts: cookies.get('oidc-authentication-ui') || 
          { "linksEnabled": false }
    };
  }

  render() {
    const disabledLink = {
        pointerEvents: 'none',
        cursor: 'default',
        color: 'black'
    };

    const enabledLink = {
        color: 'blue-30'
    };

    var togA = (
        this.state.page_opts["linksEnabled"] ? enabledLink : disabledLink
    );

    return (
      <div>
        <p className="usa-font-lead">The HPCMP OpenID Connect server provides a centralized authentication service for HPCMP users. To learn more about OpenID Connect, visit the <a style={ togA } href="https://openid.net/connect/">official website</a>.</p>
        <h3>For Users</h3>
          <p>HPCMP websites will send you here to be authenticated using either your {App.whatzIt} or Kerberos credentials. You&#x27;ll be redirected back to the website once authentication is complete.</p>
          <p>If you are still unsure about what you are doing and would like to contact the <a style={ togA } href="https://helpdesk.hpc.mil/">HPC Help Desk</a>, please email <a style={ togA } href="mailto:help@helpdesk.hpc.mil">help@helpdesk.hpc.mil</a>.</p>
        <h3>For Website Developers</h3>
          <p>HPCMP websites can use OpenID Connect to rely on the HPCMP OpenID Connect server to authenticate users. Relying Party websites can make use of numerous <a style={ togA } href="https://openid.net/developers/certified/">certified OpenID Connect implementations</a>. The HPCMP OpenID Connect server supports <a style={ togA } href="http://openid.net/specs/openid-connect-registration-1_0.html">dynamic registration</a>, and you can view its <a style={ togA } href="/.well-known/openid-configuration">configuration information</a>.</p>
          <p>If you need your website to be registered with the server then please contact the <a style={ togA } href="mailto:secdev-auth@dren.mil">server administrator</a>.</p>
      </div>
    );
  }
}

export default Landing



// WEBPACK FOOTER //
// ./src/Landing.jsx